import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const CellLabel = styled('td')`
  ${({ theme }) => theme.typography.tinyStrong}
`;

export const ToggleCellLabel = styled('div')`
  color: ${({ theme }) => theme.color.spaceGray};
`;

export const RowHeading = styled('th')`
  ${media.mdDown`
    max-width: 110px;
  `}
  overflow: hidden;
  text-overflow: ellipsis;
`;
